import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Add from '@material-ui/icons/Add'
import Edit from '@material-ui/icons/Edit'
import {Objects} from "../index";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import {confirmAlert} from "react-confirm-alert";

export default class Projects extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Manager_Tasks._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.modalTaskAdd = false;
		this.state.filterDate = moment(Date.now()).format();
		this.state.highlightRow = null;
		this.rowRefs = [];
	}

	async componentDidMount() {
		super.componentDidMount();
	}

	async componentDidUpdate(prevState, prevProps, snapshot) {
		const { location } = this.props.history;

		if (this.state.filter.filter !== this.props.filter) {
			await this.fetchData();
		}

		//handle tab change and "search"
		if(this.props.history.location.hash.includes("?pkey")){
			const queryString = this.props.history.location.hash.split('?')[1];
			const hashTab = this.props.history.location.hash.split('?')[0];
			const params = new URLSearchParams(queryString);
			const result = Object.fromEntries(params.entries());

			if (this.state.highlightRow !== result.pkey) {
				if(typeof this.props.handleTabChange === 'function'){
					//slice it to take the hashtag off the beginning
					this.props.handleTabChange(event, hashTab.slice(1))
				}

				//set highlighted row for the table to grab
				this.setState({ highlightRow: result.pkey }, () => {
					//clear the params from the hash after setting state
					this.props.history.replace({
						...location,
						hash: hashTab
					});
				});

				//scroll to the row
				const row = this.rowRefs[result.pkey];
				if (row) {
					row.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}
			}
		}
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	fetchData = async (state) => {
		this.state.limit = 15;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.day = this.state.filterDate;
		this.state.filter.filter = this.props.filter;
		// console.log('IN HERE', this.state.filter.filter, this.props.filter)
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	formatData = async (res) => {
		let returnable = [];
		await Promise.all(res.rows.map(async (row) => {
			const {manager_tasks_commentss, date_done, ...rest} = row;
			if (manager_tasks_commentss) {
				returnable.push({...rest, date_done});
				await Promise.all(manager_tasks_commentss.map((item) => {
					item.date_done = !item.description.includes('marked this Action Item') ? date_done : null;
					returnable.push(item)
					return item;
				}));
			} else {
				returnable.push(row);
			}
			return true;
		}))
		res.rows = returnable;
		return res;
	}

	handleDateChange = async (name, date) => {
		this.state.filterDate = moment(date).format();
		this.handleToggleModal('showDate');
		await this.fetchData();
	}

	handleDescriptionAdd = async () => {
		let model = new API.BuildClass(Types.Manager_Tasks_Comments._name, API.RequestType.CREATE);
		this.read = 'PUT';
		model.object.description = this.state.descriptionAdd;
		model.parent = this.state.selectedPkey;
		model.object.parent = this.state.selectedPkey;
		this.data = await model.submit(null, this.read);
		this.setState({
			descriptionAdd: '',
			selectedPkey: null,
			modalTaskAdd: false,
			key: Math.random()
		});
		await this.fetchData();
	}

	handleDescriptionEdit = async () => {
		let model = new API.BuildClass(this.state.isTitle ? Types.Manager_Tasks._name : Types.Manager_Tasks_Comments._name, API.RequestType.UPDATE);
		this.read = 'POST';
		model.object.description = (this.state.descriptionCommentAdd + (this.state.selectedCommentDescription.includes('(||') ? `(||${this.state.selectedCommentDescription.split('(||')[0].trim()}||)` + ` (||${this.state.selectedCommentDescription.split('(||').splice(1).join("(||")}` : ` (||${this.state.selectedCommentDescription}||)`));
		model.object.pkey = this.state.selectedCommentPkey;
		model.parent = this.state.isTitle ? null : 0;
		this.data = await model.submit(null, this.read);
		this.setState({
			descriptionCommentAdd: '',
			selectedCommentPkey: null,
			modalTaskEdit: false,
			isTitle: false,
			key: Math.random()
		});
		await this.fetchData();
	}

	handleDone = async (data) => {
		let model = new API.BuildClass(Types.Manager_Tasks._name, API.RequestType.UPDATE);
		this.read = 'POST';
		model.object = data;
		model.object.date_done = moment().format()

		this.data = await model.submit(null, this.read);
		this.setState({
			key: Math.random()
		});
		await this.fetchData();
	}

	handleReadd = async (original) => {
		let model = new API.BuildClass(Types.Manager_Tasks._name, API.RequestType.CREATE);
		this.read = 'PUT';
		model.object = original;
		model.object.pkey = null;
		model.object.date_done = '2021-01-01T00:00:00';
		this.data = await model.submit(null, this.read);
		this.setState({
			key: Math.random()
		});
		await this.fetchData();
	}

	approve = (original) => {
		confirmAlert({
			title: 'Confirm Re-Addition',
			message: "Are you sure you wish to add this to today's projects?",
			buttons: [
				{
					label: "Add to Today's Projects",
					color: 'danger',
					onClick: async () => {
						await this.handleReadd(original);
					}
				},
				{
					label: 'Cancel',
					onClick: () => {
					}
				}
			]
		});
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns =
			[
				{
					Header: "Created",
					id: "created",
					width: 180,
					/** @param {Manager_Tasks_Object} obj */
					accessor: obj => obj.title ? obj.created ? moment(obj.created).tz("America/Chicago").format('hh:mma z MM/DD') : '' : ''
				},
				{
					Header: "Action Item",
					id: 'action_item',
					width: 350,
					accessor: "title",
				},
				{
					Header: "User",
					id: "date_due",
					/** @param {Manager_Tasks_Object} obj */
					accessor: obj => obj.created_user ? obj.created_user : 'Admin'
				},
				{
					Header: "Activity",
					id: 'description',
					width: 900,
					accessor: obj => obj.description,
					Cell: props => {
						const old_comments = props.original.description.includes("(||") ? props.original.description.replaceAll('||)', '').split("(||") : [];
						old_comments.shift();
						const new_comment = props.original.description.split("(||")[0];
						return (
							<div className={'row'} ref={(el) => (this.rowRefs[props.original.pkey] = el)}>
								<div className={props.original.title && this.props.allowDone ? 'col-10' : 'col-11'}
								     style={{
									     whiteSpace: 'pre-wrap',
									     paddingTop: 5,
									     paddingBottom: 5,
									     fontStyle: props.original.description?.includes('marked this Action Item as done.') ? 'italic' : 'inherit'
								     }}>
									<span style={{marginRight: 5}}>{new_comment}{!props.original.title && <span><br/>-{props.original.created_user ? props.original.created_user : 'Admin'} @ {props.original.created ? moment(props.original.created).tz("America/Phoenix").format('hh:mma z MM/DD') : ''}</span>}</span>
									<br/>
									{old_comments.map((comment) => <span><s style={{marginRight: 5}}>{comment.trim()}</s><br/></span>)}
								</div>
								{props.original.title && <div className={'col-1'} style={{placeSelf: 'flex-end'}}>
									<Button color={props.original.date_done ? "warning" : "green-meadow"} size={"sm"} block={true} onClick={() => {
										this.setState({selectedPkey: props.original.pkey});
										if (props.original.date_done) {
											this.approve(props.original);
										} else {
											this.handleToggleModal('modalTaskAdd')
										}
									}}>
										<Add fontSize={'small'}/>
									</Button>
								</div>}
								{((!props.original.title && (props.original.creator ?? 'Admin') === (this.props.user ?? 'Admin')) || (props.original.title && this.props.allowDone)) &&
									<div className={'col-1'} style={{placeSelf: 'flex-end'}}>
										<Button color={"green-meadow"} size={"sm"} block={true}
										        onClick={() => {
											        this.setState({modalTaskEdit: true, selectedCommentDescription: props.original.description, selectedCommentPkey: props.original.pkey, isTitle: !!props.original.title, descriptionCommentAdd: new_comment})
										        }}>
											<Edit fontSize={'small'}/>
										</Button>
									</div>}
							</div>
						)
					}
				},
				{
					Header: "Done",
					id: "done",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 73,
					accessor: obj => obj.pkey,
					Cell: props => {
						return (
							<div className={'row'}>
								{props.original.title && <div className={'col-12'}>
									<div style={{textAlign: 'center'}}>
										<Checkbox
											checked={!!props.original.date_done}
											disabled={!!props.original.date_done || !this.props.allowDone}
											onChange={async () => {
												await this.handleDone(props.original)
											}}
											color={'primary'}
											style={{paddingTop: 3, paddingBottom: 3}}
										/>
									</div>
								</div>}
							</div>
						);
					}
				},
			]
		return (
			<div className={'box-body'}>
				<div className={'table-bar'}>
					<div>
						<Modal
							isOpen={this.state.showDate}
							toggle={() => this.handleToggleModal('showDate')}
							size={"sm"}
							backdrop={true}
							style={{display: "none"}}
						>
							<ModalBody>
								<Framework.Elements.Date
									label={"Custom Date"}
									value={this.state.filterDate}
									update={this.handleDateChange}
									open={this.state.showDate}
									clearable={false}
									cancelLabel={''}
								/>
							</ModalBody>
						</Modal>

						<Modal
							isOpen={this.state.modalTaskAdd}
							toggle={() => this.handleToggleModal('modalTaskAdd')}
							size={"md"}
							backdrop={true}
							title={'Add Comment'}
						>
							<ModalHeader>
								New Comment
							</ModalHeader>
							<ModalBody>
								<div className={'row'}>
									<div className={'col-12'}>
										<div className="form-group">
											<TextField
												fullWidth={true}
												size={"small"}
												label={"Description"}
												value={this.state.descriptionAdd}
												onChange={(e) =>
													this.setState({descriptionAdd: e.currentTarget.value})}
												variant="outlined"
												multiline={true}
												rows={4}
												// style={{marginTop: '20px'}}
											/>
										</div>
									</div>
									<div className={'col-12'}>
										<Button color="blue-hoki" size={"sm"} block={true} onClick={this.handleDescriptionAdd}>
											Add Comment
										</Button>
									</div>
								</div>
							</ModalBody>
						</Modal>
						<Modal
							isOpen={this.state.modalTaskEdit}
							toggle={() => this.handleToggleModal('modalTaskEdit')}
							size={"md"}
							backdrop={true}
							title={this.state.isTitle ? 'Edit Action Item Description' : 'Edit Comment'}
						>
							<ModalHeader>
								{this.state.isTitle ? "Edit Action Item Description" : "Edit Comment"}
							</ModalHeader>
							<ModalBody>
								<div className={'row'}>
									<div className={'col-12'}>
										<div className="form-group">
											<TextField
												fullWidth={true}
												size={"small"}
												label={"Description"}
												value={this.state.descriptionCommentAdd}
												onChange={(e) =>
													this.setState({descriptionCommentAdd: e.currentTarget.value})}
												variant="outlined"
												multiline={true}
												rows={4}
												style={{marginTop: '20px'}}
											/>
										</div>
									</div>
									<div className={'col-12'}>
										<Button color="blue-hoki" size={"sm"} block={true} onClick={this.handleDescriptionEdit}>
											{this.state.isTitle ? "Edit Action Item Description" : "Edit Comment"}
										</Button>
									</div>
								</div>
							</ModalBody>
						</Modal>
						<div className={"row rbc-toolbar pl-3"}>
							<div>
								<IconButton onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).subtract(1, 'day').format()}, async () => {
										await this.fetchData();
									})
								}}><LeftArrowIcon/></IconButton>
								<button className="rbc-today" type="button" onClick={async () => {
									this.setState({filterDate: moment(Date.now()).format()}, async () => {
										await this.fetchData();
									})
								}}>Today
								</button>
								<IconButton onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).add(1, 'day').format()}, async () => {
										await this.fetchData();
									})
								}}><RightArrowIcon/></IconButton>
							</div>
							<div className={"rbc-toolbar-label"}>
								<label onClick={() => {
									this.handleToggleModal('showDate')
								}}>
									{moment(this.state.filterDate).format('dddd MMM D')}
								</label>
							</div>
						</div>
						<div className="d-flex">
							{this.renderSearch('Projects')}
						</div>
					</div>
				</div>
				<Card>
					<CardContent>
						<ReactTable
							key={this.state.key}
							columns={columns}
							onPageSizeChange={this.onPageSizeChange}
							pageSize={data.length}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={1} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							getTdProps={(state, rowInfo, instance) => {
								return {
									style: {
										textDecoration: rowInfo?.original.date_done || rowInfo?.original.parent_completed_date ? 'line-through' : '',
										background: rowInfo.original.pkey == this.state.highlightRow ? 'red' : 'white'
									}
								}
							}}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: 'ranking'
								}
							]}
							showPagination={true}
							pageSizeOptions={[data.length]}
							defaultPageSize={data.length}
							className="-striped -highlight"
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
			</div>
		)
	}
}
